module.exports = __webpack_public_path__ + "img/usa-flag.9775de8.png";